const mapdataes = {
    applicationData: {
        title: "应用场景广阔",
        subTitle: "学好地图技术，轻松应对各种相关场景需求",
        enTitle: "WIDE APPLICATION",
        items:[{
                icon: require('./img/map/icon_01.png'),
                title: "网约车行业",
                desc: "在网约车场景中实现准定位、导航、司乘同显、精准计费等核心需求"
            },
            {
                icon: require('./img/map/icon_02.png'),
                title: "智能穿戴产品",
                desc: "实现智能穿戴设备定位、导航、轨迹追踪等各种需求"
            },
            {
                icon: require('./img/map/icon_03.png'),
                title: "智能物流行业",
                desc: "智能物流解决方案中，地图技术支撑物流下单、分单、干线运输规划、轨迹管理等多类业务场景"
            },
            {
                icon: require('./img/map/icon_04.png'),
                title: "智能景区",
                desc: "通过地图服务实现景区智能化、场景化，打造个性化智能景区"
            },
            {
                icon: require('./img/map/icon_05.png'),
                title: "互联网房产",
                desc: "深度满足房产行业搜索、位置展示、周边POI查看、路线规划等地图相关需求，优化用户体验"
            },
            {
                icon: require('./img/map/icon_06.png'),
                title: "金融保险",
                desc: "提供基于金融保险场景的外勤管理、风控识别、智慧营销、境外地图服务，提高业务效率，降低金融欺诈风险"
            },
            {
                icon: require('./img/map/icon_07.png'),
                title: "车联网",
                desc: "汽车企业通过地图数据和在线地图服务，实现车载导航、自动驾驶和手车互联等场景需求"
            },
            {
                icon: require('./img/map/icon_08.png'),
                title: "生活服务",
                desc: "深入生活服务场景，为外卖、送药、B2C零售、商超便利等提供完整的地图服务，帮助企业提高派单、配送效率，优化用户体验"
            }
        ]
    },
    mapApiMoudleData: {
        title: "入门篇-地图基本API应用",
        subTitle: "不仅学习官方基本使用，更有自研小案例帮你巩固知识",
        enTitle: "PRIMARY",
        cont:{
            image: './img/map/map.png',
            title: '地图找房案例',
            desc: '在房源信息类网站中，为了方便用户查找房源，推出了地图找房的功能，房源数据展示更加的直观',
            labelTit: '功能特点：',
            labelList: [
                {title: '【实现原理】', desc: '用户可以在地图模式中查找房源，并且可以通过缩放和移动地图进行不同粒度的查询，其实现原理是根据地图的可视范围的坐标点，在MongoDB中进行矩形条件查询，并且在结果中针对不同维度的数据进行聚合操作'},
                {title: '【复用场景】', desc: '此技术还可以用于查询附近的商店、饭店等业务场景'}
            ]
        }
    },
    trackServerDate:{
        title: "进阶篇-鹰眼轨迹服务",
        subTitle: "自主研发「轻骑」、「金运物流」项目，带你轻松掌握鹰眼轨迹服务",
        enTitle: "INTERMEDIATE",
        topLab:{
            title:'服务概述',
            subTitle:'鹰眼是一套轨迹管理服务，提供各端SDK和API供开发者便捷接入，追踪所管理的车辆/人员等物体的运动轨迹',
            desc:'基于鹰眼提供的接口和云端服务，开发者可以迅速构建一套属于您自己的完整、精准且高性能的轨迹管理系统，可应用于车队管理、人员管理等领域'
        },
        objectInfo:{
            title: "「运动健康与社交」项目的运用",
            desc: "「轻骑」项目是一个基于微信小程序的骑行运动类的应用，类似Keep应用。主要是记录用户的骑行运动轨迹、保存路线、分享路线、附近的人、附近的路线等功能，对于运动轨迹的实现主要基于百度地图的鹰眼轨迹服务实现",
            icon: require('./img/map/icon_mob.png'),
            labTitle: '体验小程序',
            ewmImg: require('./img/map/icon_01.png'),
            capabilityItems:[
                {
                    title:'附近路线和人',
                    bigImage: require('./img/map/img_phone_list.png'),
                    descList:[
                        {tit: '【复用场景】', desc:'此技术还可以用于查询附近的商店、饭店等业务场景'},
                        {tit: '【实现原理】', desc:'用户可以查看附近的路线和人，找到感兴趣的路线后沿着该路线骑行运动，其实现原理是根据中心点坐标+距离（半径）画圆，在MongoDB中按照圆形范围查询'}
                    ]
                },
                {
                    title:'查询正在骑行的人',
                    bigImage: require('./img/map/img_phone_route.png'),
                    descList:[
                        {tit: '【复用场景】', desc:'此项技术还可以用于网约车软件中查询车辆位置的功能中'},
                        {tit: '【实现原理】', desc:'用户在沿着某条路线骑行运动时，可查看一起骑行的人，实现该功能需要在底层数据库中记录自己的路线与目标路线之间的关系，同时也要记录用户的位置'}
                    ]
                }
            ]
        }
    },
    logisticsMapData: {
        title: '「物流」项目的运用',
        items:[
            {
                title: '智能调度 — 路线规划',
                bigImage: require('./img/map/img_map_route.png'),
                descList:[
                    {
                        tit: '【复用场景】',
                        des: '此项技术还可以用于网约车路线规划、导航路线规划等场景'
                    },{
                        tit: '【实现原理】',
                        des: '路线规划是物流智能调度系统中极为重要的一部分，可以根据物流仓库、限行等因素进行对运输路线的规划，其原理是通过调用百度地图服务获取到路线轨迹点，将轨迹点在地图中展现出来'
                    },
                ]
            },
            {
                title: '车辆轨迹监控',
                bigImage: require('./img/map/img_map_car.png'),
                descList:[
                    {
                        tit: '【复用场景】',
                        des: '此项技术还可用于电话手表中对于活动轨迹监控的场景中'
                    },{
                        tit: '【实现原理】',
                        des: '为了有效监控车辆的运行轨迹，可以在地图上创建电子围栏，其实现原理是在地图中选取多个点组成多边形区域，将车辆与该区域绑定关联起来，即可实时监控车辆是否超出电子围栏'
                    },
                ]
            },
        ]
    }
}
export default mapdataes